import React, { useEffect, useState } from 'react';
import Carousel from '@magalu/stereo-ui/molecules/Carousel';
import { bool, node } from 'prop-types';
import { EXHIBITION_CARDS_DESKTOP, EXHIBITION_CARDS_MOBILE } from './helpers';
import { GridContainer, GridCard } from './product-review-gallery.styles';

const ProductReviewGallery = ({
  children,
  isMobile
}) => {
  const [itemsPerView, setItemsPerView] = useState(EXHIBITION_CARDS_MOBILE);
  useEffect(() => {
    if (!isMobile) {
      setItemsPerView(EXHIBITION_CARDS_DESKTOP);
    }
  }, []);

  const renderCarousel = slidesPerView => {
    return /*#__PURE__*/React.createElement(Carousel, {
      showArrowControls: true,
      showControls: false,
      auto: false,
      slidesPerView: slidesPerView
    }, children);
  };

  if (children.length > itemsPerView) {
    return renderCarousel(itemsPerView);
  }

  return /*#__PURE__*/React.createElement(GridContainer, {
    "data-testid": "gallery-without-carousel"
  }, /*#__PURE__*/React.createElement(GridCard, null, children));
};

process.env.NODE_ENV !== "production" ? ProductReviewGallery.propTypes = {
  children: node,
  isMobile: bool
} : void 0;
export default ProductReviewGallery;